import { TableCell, TableRow, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
    titleCell: {
        width: '40%',
    },
    dataCell: {
        width: '60%',
    },
}));

export const TableRowTextField = (props: {
    name: string,
    title: string,
    value?: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    multiline?: boolean
    rows?: number
}) => {
    const classes = useStyles();

    return (
        <TableRow>
            <TableCell className={classes.dataCell} colSpan={2}>
                <TextField
                  fullWidth
                  label={props.title}
                  name={props.name}
                  onChange={props.onChange}
                  value={props.value}
                  variant="outlined"
                  multiline={props.multiline}
                  rows={props.rows}
                />
            </TableCell>
        </TableRow>
    );
};

export default TableRowTextField;